import type { AppRole } from "./auth";

/** Canonical permission keys (must match backend `has_admin_permission`). */
export const ALL_ADMIN_PERMISSIONS = [
  "manage_students",
  "manage_clients",
  "manage_competitions",
  "manage_judges",
  "manage_team",
  "manage_announcements",
  "manage_inquiries",
  "manage_domains",
  "manage_campus_admins",
] as const;

export type AdminPermissionKey = (typeof ALL_ADMIN_PERMISSIONS)[number];

export const PERMISSION_LABELS: Record<AdminPermissionKey, string> = {
  manage_students: "Manage students",
  manage_clients: "Manage clients",
  manage_competitions: "Manage competitions",
  manage_judges: "Manage judges",
  manage_team: "Manage team",
  manage_announcements: "Manage announcements",
  manage_inquiries: "Manage inquiries",
  manage_domains: "Manage email domains",
  manage_campus_admins: "Manage campus admins",
};

const LIC_RM_DEFAULT: AdminPermissionKey[] = [
  "manage_students",
  "manage_clients",
  "manage_competitions",
  "manage_judges",
  "manage_announcements",
  "manage_inquiries",
  "manage_domains",
  "manage_campus_admins",
];

/** Mirrors backend role-default `admin_permissions` for invites / reset. */
export function defaultPermissionsForRole(role: AppRole): string[] {
  if (role === "super_admin") return [...ALL_ADMIN_PERMISSIONS];
  if (role === "admin_licensing" || role === "admin_rm") return [...LIC_RM_DEFAULT];
  return [];
}

export function isSuperAdminRole(role: AppRole | null | undefined): boolean {
  return role === "super_admin";
}
